import { jsx as _jsx } from "react/jsx-runtime";
import { getDialogueImages, getArchivedDialogueImages, archiveDialogueImage, restoreDialogueImage } from '../../api/dialogue-images';
import { getLevelDialogues } from '../../api/dialogues';
import EntityArtManager from '../EntityArtManager/EntityArtManager';
import './DialoguesArt.scss';
const linkage = {
    strategy: 'sequential',
    load: getLevelDialogues,
    loadErrorMessage: 'Failed to load dialogues for images linkage',
    describeLinks: (img, dialogues) => {
        const linked = dialogues.filter(d => d.backgroundImageId === img.id);
        const linkCount = linked.length;
        let badgeText = '';
        if (linkCount > 0) {
            const firstName = linked[0].name;
            badgeText = linkCount === 1 ? firstName : `${firstName} +${linkCount - 1}`;
        }
        return {
            count: linkCount,
            badgeText,
            badgeTitle: `${linkCount} linked dialogue${linkCount !== 1 ? 's' : ''}`,
        };
    },
};
const DialoguesArt = ({ levelId, refreshTrigger }) => (_jsx(EntityArtManager, { levelId: levelId, refreshTrigger: refreshTrigger, title: "Dialogue Backgrounds", containerClassName: "dialogues-art-container", listImages: getDialogueImages, listArchivedImages: getArchivedDialogueImages, archiveImage: archiveDialogueImage, restoreImage: restoreDialogueImage, linkage: linkage }));
export default DialoguesArt;
